import React, {FC} from "react"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {Body, H4} from "@irati/ui/src/Typography"
import Hr from "@irati/ui/src/Layout/Hr"

import {EmailCheckbox, ResponsiveFlex} from "./styled/ContactPreference"

interface Props extends InjectIntl {
  title: string
  description: string
  checkboxName: string
  email: boolean
  onToggleEmail: (value: boolean) => void
  renderHR?: boolean
  isExternalPage?: boolean
}

const ContactPreference: FC<Props> = ({
  title,
  description,
  checkboxName,
  email,
  onToggleEmail,
  renderHR,
  isExternalPage,
  formatMessage
}) => {
  const emailCheckboxId = `${checkboxName}_email_checkbox`

  return (
    <>
      <Flex justifyContent="space-between" alignItems="center">
        <ResponsiveFlex direction="column" isExternalPage={isExternalPage}>
          <H4 marginBottom={1}>{formatMessage({id: title})}</H4>
          <Body small width="75%">
            {formatMessage({id: description})}
          </Body>
        </ResponsiveFlex>
        <EmailCheckbox name={emailCheckboxId} checked={email} onChange={() => onToggleEmail(!email)} isExternalPage={isExternalPage} />
      </Flex>
      {renderHR && <Hr />}
    </>
  )
}

export default injectIntl<Props>(ContactPreference)
